export default {
  //* loadCampaigns ---------------------------------------------------------------------------------------------------------------

  async loadCampaigns({ rootGetters, commit }) {
    // load contacts from backend
    /*
			! ATTENTION: 
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      resp_json = {};
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getCampaigns/all", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setCampaigns", resp_json);
      localStorage.setItem("campaigns", JSON.stringify(resp_json));
    }
  },

  //* addCampaign ---------------------------------------------------------------------------------------------------------------

  async addCampaign({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION: 
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/addCampaign", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },
};
